import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Hook for automatically navigating to a specified path after a delay
 * @param path - The path to navigate to
 * @param delay - The delay in milliseconds before navigation (default: 2000ms)
 */
export const useAutoNavigate = (path: string): void => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(path);
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate, path]);
};

